import { render } from "./Tile.vue?vue&type=template&id=0b9ef53e&scoped=true&bindings={\"icon\":\"props\",\"background\":\"props\",\"size\":\"props\",\"isActive\":\"props\",\"isStatic\":\"props\",\"backgroundColor\":\"props\",\"tileStyle\":\"options\"}"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"

import "./Tile.vue?vue&type=style&index=0&id=0b9ef53e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b9ef53e"

export default script